import React from 'react';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type TechStackGroup = {
  group: string;
  names: string[];
};

type TechStackPreviewProps = {
  /** 技術レイヤーのグループ一覧 */
  layerGroups: TechStackGroup[];
  /** 技術種別のグループ一覧 */
  typeGroups: TechStackGroup[];
};

/**
 * 技術スタックをカテゴリ別にChip一覧で表示する共通プレビューコンポーネント。
 * TechStackFormFieldのプレビューと同じ見た目で表示する。
 * プロジェクト詳細、契約詳細、テンプレート詳細等で利用する。
 */
const TechStackPreview: React.FC<TechStackPreviewProps> = ({ layerGroups, typeGroups }) => {
  if (layerGroups.length === 0 && typeGroups.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={3} sx={{ pt: 0.5 }}>
      {/* 技術レイヤー列 */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ mb: 1 }}>
          技術レイヤー
        </Typography>
        {layerGroups.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            —
          </Typography>
        ) : (
          <Stack spacing={1} sx={{ mt: 0.5 }}>
            {layerGroups.map(({ group, names }) => (
              <Box key={group}>
                <Typography variant="caption" color="text.secondary">
                  {group}
                </Typography>
                <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 0.25 }}>
                  {names.map((name) => (
                    <Chip key={name} label={name} size="small" sx={{ borderRadius: 1.5 }} />
                  ))}
                </Stack>
              </Box>
            ))}
          </Stack>
        )}
      </Box>

      {/* 技術種別列 */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary" fontWeight={600} sx={{ mb: 1 }}>
          技術種別
        </Typography>
        {typeGroups.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            —
          </Typography>
        ) : (
          <Stack spacing={1} sx={{ mt: 0.5 }}>
            {typeGroups.map(({ group, names }) => (
              <Box key={group}>
                <Typography variant="caption" color="text.secondary">
                  {group}
                </Typography>
                <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ mt: 0.25 }}>
                  {names.map((name) => (
                    <Chip key={name} label={name} size="small" sx={{ borderRadius: 1.5 }} />
                  ))}
                </Stack>
              </Box>
            ))}
          </Stack>
        )}
      </Box>
    </Stack>
  );
};

export default TechStackPreview;
